import { useEffect, useState } from "react";
import { getCurrentUser, User, USER_ROLES, UserService } from "../../services/User";
import { Button, message, Popconfirm, Select, Space } from "antd";
import Table, { ColumnsType } from "antd/es/table";
import { useNavigate } from "react-router-dom";
import './list.css'
import { Country, CountryService } from "../../services/Country";

const UserList: React.FC = () => {
    const [users, setUsers] = useState<User[]>([]);
    const [countries, setCountries] = useState<Country[]>([])
    const navigate = useNavigate();
    const currentUser = getCurrentUser();

    const getUsers = async (country?: string) => {
        const { data } = await UserService.getAll(country);
        setUsers(data);
    }
    
    const getCountries = async () => {
        const {data} = await CountryService.getAll()
        setCountries(data)
    }

    useEffect(() => {
        const country = currentUser.role != 'admin' ? currentUser.country as string  : undefined;
        getUsers(country);
        getCountries();
    }, [])

    const handleEdit = (userId: string) => {
        navigate(`/admin/users/edit/${userId}`)
    };

    const handleDelete = async (userId: string) => {
        const {data} = await UserService.delete(userId);
        setUsers(users.filter(u => u._id != userId))
        message.warning('User deleted');
    };

    const columns: ColumnsType<User> = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Country',
            dataIndex: 'country',
            key:'country',
            render: (_, record) => (
                <span> {(record?.country as Country)?.name} </span>
            )
        },
        {
            title: 'Role',
            dataIndex: 'role',
            key:'role',
            render: (_, record) => (
                <span> { record.role }</span>
            )
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Button type="link" onClick={() => handleEdit(record._id)}>Edit</Button>
                    <Popconfirm
                        title="Are you sure you want to delete this user?"
                        onConfirm={() => handleDelete(record._id)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button type="link" danger>Delete</Button>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    const handleChange = async(event: any) => {
        await getUsers(event)
    }

    const handleClear = async() => {
        await getUsers()
    }

    return (
        <div>
            <Space className="add-button-users">
                {currentUser.role===USER_ROLES.ADMIN && <Select onChange={handleChange} style={{width:150}} onClear={handleClear} allowClear placeholder="Country">
                    {countries.map(country => (
                        <Select.Option value={country._id} key={country._id}>
                            {country.name}
                        </Select.Option>
                    ))}
                </Select>}
                <Button type="primary" onClick={() => navigate('/admin/add-user')}>+Add User</Button>
            </Space>
            <Table columns={columns} dataSource={users} rowKey='_id'/>
        </div>
    );
};

export default UserList;
